import type { RouteRecordRaw } from 'vue-router';
import { customerOrderRoute, orderDetailRoute, orderRoute, orderPackingRoute } from '@/pages/order/route';

export const orderRoutes: RouteRecordRaw = {
    path: '/order',
    component: () => import('@/layouts/main.vue'),
    children: [
        orderRoute(),
        customerOrderRoute(),
        orderDetailRoute(),
        orderPackingRoute(),
    ],
};
